export default __webpack_public_path__ + "static/media/granville_mini.500d24b6.jpg";